import { Component } from "@angular/core"
import { ViewController, ActionSheetController, ModalController } from "ionic-angular"

import { AppLocalStorage } from "../../services/app-local-storage"
import { ProfilePicturePage } from "./picture"
import { ProfileDataPage } from "./data"
import { ProfilePasswordPage } from "./password"
import { ProfileEmailPage } from "./email"

@Component({
  selector: "profile-page",
  templateUrl: "index.html",
})
export class ProfilePage {

  user: any = {}

  constructor(
    private viewCtrl: ViewController,
    private actionSheetCtrl: ActionSheetController,
    private modalCtrl: ModalController
  ) {

    this.user = AppLocalStorage.get("user")
  }

  ionViewWillEnter() {

    this.viewCtrl.setBackButtonText("Voltar")
  }

  onUpdate() {

    this.actionSheetCtrl.create({
      title: "O que você deseja atualizar ?",
      buttons: [
        {
          text: "Foto do perfil",
          handler: () => {

            const modal =  this.modalCtrl.create(ProfilePicturePage, { user: this.user })

            modal.onDidDismiss((picture) => {

              if (picture) {
                this.user.picture = picture
                this.updateLocalStorageData()
              }
            })

            modal.present()
          },
        },
        {
          text: "Dados pessoais",
          handler: () => {

            const modal = this.modalCtrl.create(ProfileDataPage, { user: this.user })

            modal.onDidDismiss((user) => {

              console.log(user)

              if (user) {
                this.user = user
                this.updateLocalStorageData()
              }
            })

            modal.present()
          },
        },
        {
          text: "Senha de acesso",
          handler: () => {

            this.modalCtrl.create(ProfilePasswordPage).present()
          },
        },
        {
          text: "E-mail",
          role: "destructive",
          handler: () => {

            const modal = this.modalCtrl.create(ProfileEmailPage, { user: this.user })

            modal.onDidDismiss((email) => {

              if (email) {
                this.user.email = email
                this.updateLocalStorageData()
              }
            })

            modal.present()
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    }).present()
  }

  updateLocalStorageData() {

    AppLocalStorage.set("user", this.user)
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/index.ts